<template>
    <article :class="['caseStudyCard', modified_class]" v-cloak>
        <a :href="url" class="caseStudyCard__link">
            <div class="caseStudyCard__text">
                <h1 v-if="title" class="caseStudyCard__title" v-html="title" />

                <ul v-if="categories" class="pills caseStudyCard__pills">
                    <li v-for="(item, i) in categories"
                        :key="i"
                        class="pill caseStudyCard__pill"
                    >{{ item.name }}</li>
                </ul>
            </div>

            <div class="caseStudyCard__bgImg">
                <img v-if="img && img.hasOwnProperty('url')"
                     :src="img.url"
                     :alt="`${title} Thumbnail`"
                     :height="img.hasOwnProperty('height') ? img.height : 650"
                     :width="img.hasOwnProperty('width') ? img.width : 484"
                     draggable="false"
                     loading="lazy"
                />
            </div>
        </a>
    </article>
</template>

<script>
export default {
    name: "CaseStudyCard",
    props: {
        url: {
            type: String,
            default() {
                return "";
            }
        },
        title: {
            type: String,
            default() {
                return "";
            }
        },
        categories: {
            type: Array,
            default() {
                return [];
            }
        },
        img: {
            type: Object,
            default() {
                return {
                    url: "",
                    height: 650,
                    width: 484
                }
            }
        },
        modifier: {
            type: String,
            default() {
                return "";
            }
        },
    },
    computed: {
        modified_class() {
            return this.modifier.length > 0 ? `caseStudyCard--${this.modifier}` : '';
        }
    }
}
</script>
